module.exports = __webpack_public_path__ + "img/9788925530635.9290058c.jpg";